import styled, { CSSObject } from 'styled-components';
import Icon from '../Icon';

export const CloseIcon = styled(Icon)(({ theme, active }) => ({
  color: active ? theme.color.wfGrey800 : theme.color.wfGrey600,
  '&:hover': {
    cursor: 'pointer',
    color: theme.color.wfRed,
  },
}));

interface TabStyledProps {
  active?: boolean;
}

export const FloatingTabStyled = styled.div<TabStyledProps>(
  ({ theme, active }) => {
    let styleSheet: CSSObject = {
      marginRight: theme.space[1],
      cursor: active ? 'default' : 'pointer',
      display: 'inline-flex',
      flexShrink: 0,
      alignItems: 'center',
      borderRadius: theme.space[1],
      padding: '0.1rem 0.5rem',
      fontSize: theme.font.size.small,
      border: `1px solid ${theme.color.wfGrey400}`,
      color: theme.color.wfGrey,
      boxSizing: 'border-box',
      ':first-child': {
        marginLeft: theme.space[2],
      },
      '&:hover': {
        background: theme.color.wfGrey50,
      },

      '-webkit-user-select': 'none' /* Safari */,
      '-moz-user-select': 'none' /* Firefox */,
      '-ms-user-select': 'none' /* IE10+/Edge */,
      'user-select': 'none' /* Standard */,
    };

    if (active) {
      styleSheet = {
        ...styleSheet,
        color: theme.color.wfBlack,
        background: 'transparent',
        borderColor: theme.color.primary,
        '&:hover': {
          borderColor: theme.color.wfGrey400,
        },
      };
    }

    return styleSheet;
  },
);
